// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body[data-v-20d598dc]{min-height:100vh}.font-primary[data-v-20d598dc],.font-primary-regular[data-v-20d598dc]{font-family:Barlow,helvetica,arial,sans-serif;font-weight:400}.to-top[data-v-20d598dc]{height:1rem;width:1rem}@q-md-min{height:1.5rem;width:1.5rem}.to-top g[data-v-20d598dc]{fill:#000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
